/* global dataLayer */

import React, { Component } from 'react';
import '@ookla/common-ui/lib/styles';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styles from './../styles/pages/methodology.css';
import c from './../utils/constants';

import locationIcon from './../images/common-static/icons/ic_location.svg';
import filteringIcon from './../images/common-static/icons/filter-new.svg';
import collectionIcon from './../images/common-static/icons/collection-new.svg';
import cmaIcon from './../images/common-static/icons/ic_cma.svg';
import fixedIcon from './../images/common-static/icons/ic_isp.svg';
import aggregationIcon from './../images/common-static/icons/ic_aggregation.svg';
import checkIcon from './../images/common-static/icons/ic_checkcircle.svg';
import summaryIcon from './../images/common-static/icons/summarize-new.svg';

import spatialIcon from './../images/common-static/icons/spatial-agg-new.svg';
import methodologyHeaderImage from './../images/awards-methodology-header-img.svg';

import process4SVGs from './../images/process4SVGs.svg';

import { Helmet } from 'react-helmet';
import Layout from '../components/layout';

export default class MethodologyPage extends Component {
  static propTypes = {
    location: PropTypes.object
  };
  getHeaderData = () => {
    return {
      title: 'Methodology | Speedtest Awards',
      desc: 'Speedtest Awards represent real world network performance and the internet speeds operators provide to their customers.'
    };
  };
  componentDidMount() {
    const {
      location: { pathname }
    } = this.props;

    const pageTitle = this.getHeaderData().title;

    // send event to GTM
    typeof dataLayer !== 'undefined' &&
      dataLayer.push({
        pageTitle,
        virtualUrl: pathname,
        event: 'virtualPageview'
      });
  }
  render() {
    const headerData = this.getHeaderData();
    const top_rated_provider_link = c.awardTypes.top_rated_provider.visible ? <a href="/awards/top-rated-fixed">Browse Top-Rated Fixed Network Awards</a> : '';
    const best_mobile_video_link = c.awardTypes.best_mobile_video_experience.visible ? <a href="/awards/best-mobile-video-experience">Browse Best Mobile Video Experience Awards</a> : '';
    const best_isp_video_experience_link = c.awardTypes.best_isp_video_experience.visible ? <a href="/awards/best-isp-video-experience">Browse Best ISP Video Experience Awards</a> : '';
    const best_5g_video_experience_link = c.awardTypes['5g_video_experience'].visible ? <a href="/awards/5g-video-experience">Browse Best 5G Video Experience Awards</a> : '';
    const best_mobile_gaming_experience_link = c.awardTypes.best_mobile_gaming_experience.visible ? <a href="/awards/best-mobile-gaming-experience">Browse Best Mobile Gaming Experience Awards</a> : '';
    const best_isp_gaming_experience_link = c.awardTypes.best_isp_gaming_experience.visible ? <a href="/awards/best-isp-gaming-experience">Browse Best ISP Gaming Experience Awards</a> : '';
    const best_5g_gaming_experience_link = c.awardTypes.best_5g_gaming_experience.visible ? <a href="/awards/best-5g-gaming-experience">Browse Best 5G Gaming Experience Awards</a> : '';
    const best_fixed_link = c.awardTypes.best_fixed.visible ?  <a href="/awards/best-fixed">Browse Best Fixed Network Awards</a> : '';
    
    return (
      <Layout>
        <div>
          <Helmet>
            <html lang="en" />
            <meta name="description" content={headerData.desc} />
            <title>{headerData.title}</title>
          </Helmet>

          <div className="section section-dark section-dark-navy section-lg">
            <div className="container">
              <div className="pure-g">
                <div className="pure-u-1 u-c">
                  <h1 className={`u-align-left ${styles.header}`}>Speedtest Awards<sup>™</sup> Methodology</h1>
                </div>

                <div className="pure-u-1 pure-u-md-1-2 u-c">
                  <p className={styles.methodologyParagraphLineHeight}>
                    With millions of results obtained with Speedtest<sup>®</sup> each day, Ookla<sup>®</sup> has the most accurate and
                    comprehensive view of worldwide network performance, quality and accessibility. Speedtest Awards
                    acknowledge operators that provide the Fastest Mobile Network, Fastest Fixed Network and Best Mobile
                    Coverage in their respective markets. Ookla's methodology for determining Speedtest Awards winners
                    is based on a robust set of criteria that is detailed on this page.
                  </p>
                  <p className={styles.methodologyParagraphLineHeight}>
                    <a href="#methodology">Speed Awards Methodology</a>
                    <a className={styles.methodologyLinkRight} href="#coverage">
                      Coverage Awards Methodology
                    </a>
                  </p>
                  <p className={styles.methodologyParagraphLineHeight}>
                    <a href="#top-rated">Top-Rated Mobile and Fixed Network Methodology</a>
                  </p>
                  {c.awardTypes.best_mobile_video_experience.visible && (
                    <p className={styles.methodologyParagraphLineHeight}>
                      <a href="#video-score">Video Awards Methodology</a>
                      {c.awardTypes.best_mobile_gaming_experience.visible && (
                        <a className={styles.methodologyLinkRight} href="#game-score">Game Score Methodology</a>
                      )}
                    </p>
                  )}


                </div>

                <div className="pure-u-1 pure-u-md-1-2 u-c">
                  <div className={styles.imgStickLeft} dangerouslySetInnerHTML={{ __html: methodologyHeaderImage }} />
                </div>
              </div>
            </div>
          </div>

          {/* Methodology List Section Start */}
          <div id="methodology" className="section section-lg section-light">
            <div className="container">
              <div className="pure-g">
                <div className="pure-u-1 ">
                  <h1 className={`u-align-center ${styles.methodologyListHeader}`}>Speed Awards Methodology</h1>
                </div>

                {/* Methodology List: Location and Provider */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: locationIcon }} /> Location &amp;
                    Provider
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      For a given location, Speedtest Awards consider only operators that provide service for a
                      significant number of customers in that geographic area. If an operator is fastest in a small city
                      or region, they may not be eligible to receive a national level award because they only serve a
                      small portion of that country. Additionally, an operator must meet a minimum threshold of the
                      number of unique devices testing each day over a six month period to be considered for a
                      geographic area. By instituting these parameters, Ookla ensures that recognition is given to
                      operators whose services are available to and used by a significant portion of the population in a
                      location.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                {/* Methodology List: Sample Construction and Aggregation */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: aggregationIcon }} /> Sample
                    construction and aggregation
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      To analyze the data behind Speedtest Awards, Ookla aggregates consumer-initiated tests taken with
                      Speedtest after they have gone through a ‘sample construction’ process that creates standardized
                      data points that can be used for advanced statistical analysis. These standardized data points are
                      what Ookla is referencing when the term samples is used.
                    </p>

                    <p className={styles.methodologyParagraph}>
                      Samples are constructed to control for variables and ensure that each unique user receives fair
                      representation in the data. Each sample represents the cumulative tests results for each unique
                      device/user per location, per calendar day. This approach improves data accuracy and reduces bias
                      from factors like repeated testing from the same device during a short time period. It is also one
                      of the many tactics Ookla takes to prevent any external skewing of Speedtest data that may aim to
                      produce fraudulent or inaccurate results.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                {/* Methodology List: Speed Score */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: checkIcon }} /> Speed score<sup>™</sup>
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      When analyzing fastest operators, Ookla solely considers top carriers (all carriers with 3% or more of total test samples in the market for the entire award period). We then determine the fastest network using Speed Score, which incorporates download speeds, upload speeds, and latency to provide a more comprehensive measure of network performance. Speed Score ranks network speed and Quality of Service (QoS) performance on a 0-100 scale, comparing each metric to a global reference for global comparison purposes.
                      Speed Score uses a logistic function to adjust the values of each metric to a 0-1 scale, centering the values relative to a global reference. This enables direct global comparisons across all networks. Metrics are taken from the 10th percentile, 50th percentile (median), and 90th percentile to capture a broad view of network performance. These values are then combined using a 1:8:1 ratio, with 80% weighting on the median, representing typical user experience across different network conditions.
                      For each network, the final Speed Score is calculated with the following weights: 70% is attributed to download speed, 20% to upload speed, and 10% to latency. These weighted, normalized values are transformed into the final Speed Score, ranging from 0 to 100, with higher scores indicating better performance.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                {/* Methodology List: Fixed Networks */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: fixedIcon }} /> Fixed networks
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      To determine Speedtest Awards winners for fixed networks, Ookla assesses the fastest speeds
                      attained across a given network, regardless of the performance tier for which an individual is
                      paying. Since access to ISP service happens over both wired and Wi-Fi connections, Ookla takes
                      into account tests that are taken on various Speedtest applications that connect to a fixed
                      network and analyzes them based on Speed Score. This includes tests taken on mobile phones through
                      a Wi-Fi connection. Each top carrier accounts for at least 3% of the sample size in the geographic
                      area.
                    </p>
                    <a href="https://www.speedtest.net/awards/fixed">Browse Fastest Fixed Awards</a>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                {/* Methodology List: Mobile Networks */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: cmaIcon }} /> Mobile networks
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      To determine Speedtest Awards winners for mobile networks, Ookla assesses the average of test
                      results taken using Modern Chipsets. Modern Chipsets includes all mobile tests, regardless of
                      connection technology used, as long as they are taken on devices that are identified as being
                      capable of achieving the fastest speeds available in a market. After this filtering has taken
                      place, Speed Score is applied as outlined above to determine the best speeds available in a
                      country. Each top carrier accounts for at least 3% of the sample size in the geographic area.
                      The Fastest 5G Mobile Network Award evaluates the speeds on 5G to determine the highest Speed Score on the technology.

                    </p>
                    <a href="https://www.speedtest.net/awards/mobile">Browse Fastest Mobile Awards</a><br />
                    {c.awardTypes['5g'].visible && (
                      <a href="https://www.speedtest.net/awards/fastest-5g">Browse Fastest 5G Mobile Awards</a>
                    )}
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>
              </div>
            </div>
          </div>
          {/* Methodology List Section End */}

          {/* Mobile Coverage Methodology Section Start */}
          <div id="coverage" className="section section-lg section-grey">
            <div className="container">
              <div className="pure-g">
                <div className="pure-u-1 pure-u-md-1-5" />
                <div className="pure-u-1 pure-u-md-3-5 u-c">
                  <h1 className={`u-align-center ${styles.methodologyListHeader}`}>Mobile coverage methodology</h1>
                  <p className={styles.methodologyParagraph}>
                    Using billions of measurements from hundreds of millions of mobile coverage scans collected by
                    Speedtest<sup>®</sup> and Consumer QoE<sup>TM</sup> users each day, Ookla<sup>®</sup> has developed a robust and comprehensive view
                    of worldwide mobile coverage. We have established an accurate and consumer-relevant methodology using
                    extensive data analytics to determine the best mobile coverage on networks around the world.
                    Our unbiased, data-driven approach controls for extraneous variables and ensures an equitable
                    accounting for all coverage scans.
                  </p>
                  <br />
                  <h2 className={`u-align-center ${styles.methodologyList}`}>Process</h2>
                  <p className={styles.methodologyParagraph}>
                    Ookla’s data analysis process for mobile coverage involves four primary steps: collection,
                    filtering, spatial aggregation, and summarization. The results of that process are then leveraged to
                    calculate and determine the Mobile Coverage Award recipients within a country.
                  </p>
                </div>
                <div className="pure-u-1 pure-u-md-1-5" />

                <div className="pure-u-1">
                  <div className={'pure-u-1 pure-u-md-5-24 pure-u-sm-2-24'} />
                  <div className="pure-u-1 pure-u-md-14-24 pure-u-sm-20-24">
                    <svg className="pure-img pure-img-full-width" dangerouslySetInnerHTML={{ __html: process4SVGs }} />
                  </div>
                  <div className={'pure-u-1 pure-u-md-6-24 pure-u-sm-2-24'} />
                </div>

                {/* Mobile Coverage Methodology List: Collection */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: collectionIcon }} /> Collection
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      Hundreds of millions of coverage scans are received daily from Android Speedtest and
                      Consumer QoE users from around the world.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                {/* Mobile Coverage Methodology List: Filtering */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: filteringIcon }} /> Filtering
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      Several data quality filters are applied to ensure the data represents true network conditions. Coverage scans are excluded from devices that are misconfigured or inactive. Because coverage is a spatially-focused metric,
                      only scans with precise and legitimate location information are included.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                {/* Mobile Coverage Methodology List: Spatial Aggregation */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: spatialIcon }} /> Spatial aggregation
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      Filtered data are grouped into spatial bins using the <a href="https://h3geo.org" target="_blank">h3 hexagonal hierarchical geospatial
                        indexing system</a> with resolution 7. This produces hexagons with an average area of approximately
                      5000 m<sup>2</sup>, which is roughly the area served by a typical cell sector.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                {/* Mobile Coverage Methodology List: Coverage Calculation */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: summaryIcon }} /> Coverage Summary
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      We classify a scan as “in coverage” if the device is successfully registered on a cell network
                      when the scan is collected and “not in coverage” if the device is out of service or has only emergency
                      service when the scan is collected.
                    </p>
                    <p className={styles.methodologyParagraph}>
                      We then assess a provider’s coverage within each hexagon. A hexagon is eligible for use in coverage
                      calculation if it has at least 5 scans and at least 2 users.  We classify each eligible hexagon as
                      “in coverage” if at least 50% of the scans within are classified as “in coverage.” Finally, we compute
                      the total number of hexagons classified as “in coverage” divided by the total number of hexagons in
                      the country (multiplied by 100) to arrive at the Coverage Score™ for a particular provider.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                <div className="pure-u-1 pure-u-md-1-5" />
                <div className="pure-u-1 pure-u-md-3-5 u-c">
                  <br />
                  <h2 className={`u-align-center ${styles.methodologyList}`}>Criteria</h2>
                  <p className={styles.methodologyParagraphPadding}>
                    All Speedtest Awards are based on six months of historical data within the same calendar year,
                    called the award period. By using a six-month time period, coverage can be examined at a fine
                    spatial scale, and any temporary changes in service can be resolved. This also reduces the likelihood
                    that short-term fluctuations in service will significantly influence the analysis.
                  </p>
                </div>
                <div className="pure-u-1" />

                {/* Criteria List: Summarization */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: checkIcon }} /> Market share and
                    geography
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      The intention of the Speedtest Mobile Coverage Award is to identify the mobile networks with the
                      best coverage that are generally available to consumers in a specific geographic area. To this end,
                      for each provider, we compute the tile share as the total number of eligible tiles
                      (see Coverage Summary) for that provider divided by the total number of eligible tiles
                      (across all providers).  In order to be eligible for the award, a provider’s tile share must be at
                      least 50%. If a provider’s tile share is less than 50%, it is an indication that they are not widely
                      available in the country.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>

                {/* Criteria List: Eligible Entities */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: checkIcon }} /> Eligible entities
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      We evaluate every mobile network operator to confirm they are actively providing consumer service in
                      the specified region. All providers must remain an individual entity during the entire award period.
                      Mergers and acquisitions will be taken into consideration when determining provider award eligibility.
                      If a provider no longer has a named presence in the market as a result of a merger or acquisition,
                      they will be excluded from Speedtest Awards consideration. Additionally, test results for a merged or
                      acquired provider will be included in the results of their new parent company on the final merger
                      date, potentially impacting the overall Coverage Score of the parent company.
                    </p>
                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>
                {/* Criteria List: Statistical Evaluation */}
                <div className={`pure-u-1 ${styles.methodologyListContent}`}>
                  <div className="pure-u-1 pure-u-md-2-24" />
                  <div className={`u-align-right pure-u-1 pure-u-md-6-24 ${styles.methodologyListTitle}`}>
                    <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: checkIcon }} /> Statistical Evaluation
                  </div>
                  <div className="pure-u-1 pure-u-md-12-24 u-c">
                    <p className={styles.methodologyParagraph}>
                      A provider is declared a winner of Best Mobile Coverage only if it consistently surpasses every other
                      provider in the country. To determine this, and correct for any underlying biases in scan counts,
                      we employ Monte Carlo bootstrapping methods to calculate coverage and to evaluate the statistical
                      uncertainty in the data. A one-sided Mann-Whitney U test in both directions is executed for each pair
                      of providers. We use an alpha value of 0.05 to evaluate the significance of the observed differences.
                      We also require an effect size, defined as the percentage difference in coverage ratios between
                      providers, to be greater than 5%.
                    </p>
                    <p className={styles.methodologyParagraph}>
                      Methodology updated July 2024. For previous methodology, see <a href="https://www.speedtest.net/awards/reports/methodology/2023_Mobile_Coverage_Methodology.pdf">2023 Mobile Coverage Methodology</a>
                    </p>

                  </div>
                  <div className="pure-u-1 pure-u-md-8-24" />
                </div>
              </div>
            </div>
          </div>
          {/* Mobile Coverage Methodology Section End */}

          {/* Top-Rated Mobile and Fixed Network Start */}
          <div id="top-rated" className="section section-lg section-light">
            <div className="container">
              <div className="pure-g">
                <div className="pure-u-1 pure-u-md-1-6" />
                <div className="pure-u-1 pure-u-md-2-3 u-c">
                  <h1 className={`u-align-center ${styles.methodologyListHeader}`}>
                    Top-Rated Mobile and Fixed Network
                  </h1>
                  <p className={styles.methodologyParagraph}>
                    Top-Rated Awards are designed to evaluate, for a specific location and time period, whether an
                    operator has the highest star rating. We use our sampled data set of Speedtest 5 Star Ratings to
                    extrapolate and make inferences about consumer sentiment amongst the broader population of
                    consumers. Statistical hypothesis testing provides a formal framework to rigorously and consistently
                    decide whether the highest rated operator can be identified from our sampled data.
                  </p>
                  <p className={styles.methodologyParagraph}>
                    To evaluate Top-Rated Awards we compare mean ratings using a modified Hsu’s Multiple Comparisons
                    with Best (MCB) procedure. This evaluates whether a “best” group can be identified from many groups,
                    based upon sampled data sets. In the case of Top-Rated Awards, this implies that we are able to
                    identify the Top Provider with the highest rating. The MCB procedure is similar to performing
                    multiple t-tests comparing each Top Provider to the best of the rest, and then combining these to
                    make a single statistical decision.
                  </p>
                  <div className="pure-u-1 u-align-center">
                    <a href="/awards/top-rated-mobile">Browse Top-Rated Mobile Network Awards</a><br />
                    {top_rated_provider_link}
                  </div>
                </div>
              </div>
              <div className="pure-u-1 pure-u-md-1-6" />
            </div>
          </div>
          {/* Top-Rated Mobile and Fixed Network End */}

          {/* Video Score Start */}
          {c.awardTypes.best_mobile_video_experience.visible && (
            <div id="video-score" className="section section-lg section-grey">
              <div className="container">
                <div className="pure-g">
                  <div className="pure-u-1 pure-u-md-1-6" />
                  <div className="pure-u-1 pure-u-md-2-3 u-c">
                    <h1 className={`u-align-center ${styles.methodologyListHeader}`}>
                      Video Experience Awards
                    </h1>
                    <p className={styles.methodologyParagraph}>
                      The Ookla Speedtest Award for Video Experience offer consumers a trustworthy assessment of the internet providers that will best meet their video streaming
                      needs. The Video Streaming Score is based on Ookla’s CQoE video test, which captures a range of key performance indicators during the playback of a 15-second, high-resolution video clip. The Video Streaming Score is calculated by evaluating three critical attributes that significantly impact user experience:</p>
                    <h3>Video Streaming Score Component Weightings:
                    </h3>
                    <ul>
                      <li className={`${styles.listHeader}`}>Acceptable Video Start Time (%)</li>
                      <ul>
                        <li>Measures the percentage of users who experience a video start time of less than 2 seconds in a majority of playbacks.</li>
                        <li>Weight: 33.33%</li>
                      </ul>
                      <li className={`${styles.listHeader}`}>Uninterrupted Playback (%):</li>
                      <ul>
                        <li>Measures the percentage of users who experience no rebuffering events during playback.</li>
                        <li>Weight: 33.33%</li>
                      </ul>
                      <li className={`${styles.listHeader}`}>Full HD Resolution (%)</li>
                      <ul>
                        <li>Measures the percentage of users who experience 1080p or higher resolution in the majority of playbacks.</li>
                        <li>Weight: 33.33%</li>
                      </ul>
                    </ul>
                    <div className="pure-u-1 u-align-center">
                      See <a href="https://www.speedtest.net/awards/reports/methodology/2025_Speedtest_Awards_Video_Experience_Methodology.pdf">Methodology Doc</a> for more information.
                    </div>
                    <div className="pure-u-1 u-align-center">
                      <br />{best_mobile_video_link}
                      <br />{best_isp_video_experience_link}
                      <br />{best_5g_video_experience_link}
                    </div>
                  </div>
                </div>
                <div className="pure-u-1 pure-u-md-1-6" />
              </div>
            </div>
          )}
          {/* Video Score End */}

          {/* Game Score Start */}
          {c.awardTypes.best_mobile_gaming_experience.visible && (
            <div id="game-score" className="section section-lg section-light">
              <div className="container">
                <div className="pure-g">
                  <div className="pure-u-1 pure-u-md-1-6" />
                  <div className="pure-u-1 pure-u-md-2-3 u-c">
                    <h1 className={`u-align-center ${styles.methodologyListHeader}`}>
                      Game Score Methodology
                    </h1>
                    <p className={styles.methodologyParagraph}>
                      Gaming Experience Awards for mobile and ISP networks are based on Ookla’s Game Score, which combines four measures of the quality of gaming experience:
                      <ul>
                        <li>Game Latency</li>
                        <li>Game Jitter</li>
                        <li>Download Speed</li>
                        <li>Upload Speed</li>
                      </ul>
                      Mobile Gaming Experience Awards are available for all network generations combined and 5G results. ISP Gaming Experience Awards are based on all fixed technologies combined. When analyzing the Best Gaming Experience offered by providers, Ookla solely considers providers with 3% or more of total Speedtest samples in the entire market for the complete award period.  To ensure that the data is accurate and reflective of consumer experience, each Game Score component is subject to Ookla’s proprietary data quality filters. We apply a user aggregation methodology to test results to ensure each user has an equal contribution to the results. This means that a user can submit any number of test results during any arbitrary time period, but they will only contribute one “vote” that represents their typical gaming experience during a given period of observation.
                    </p>
                    <div className="pure-u-1 u-align-center">
                      See <a href="https://www.speedtest.net/awards/reports/methodology/2023_Gaming_Award_Methodology.pdf">Methodology Doc</a> for more information.
                    </div>
                    <div className="pure-u-1 u-align-center">
                      <br />
                      {best_5g_gaming_experience_link}<br />
                      {best_isp_gaming_experience_link}<br />
                      {best_mobile_gaming_experience_link}
                    </div>
                  </div>
                </div>
                <div className="pure-u-1 pure-u-md-1-6" />
              </div>
            </div>
          )}
          {/* Game Score End */}


          {/* Best Fixed Start */}
          {(
            <div id="game-score" className="section section-lg section-grey">
              <div className="container">
                <div className="pure-g">
                  <div className="pure-u-1 pure-u-md-1-6" />
                  <div className="pure-u-1 pure-u-md-2-3 u-c">
                    <h1 className={`u-align-center ${styles.methodologyListHeader}`}>
                      Best Network Award
                    </h1>
                    <p className={styles.methodologyParagraph}>
                      Ookla’s Best Network Award's™, based on Speedtest Connectivity Score™, provides a reliable measure of the overall network connected experience. The Speedtest Connectivity Score is calculated by combining pillar scores for Speed Score, Web Browsing, and Video Streaming. These pillars represent the major aspects of connectivity, and each one is weighted differently in the final score.                    </p>
                    <p>
                      <div className={`${styles.subHeader}`}>Speedtest Connectivity Score Component Weightings:</div>
                      <ul>
                        <li>Speed Score: 50%</li>
                        <li>Web Browsing Score: 25%</li>
                        <li>Video Streaming Score: 25%</li>
                      </ul>
                    </p>
                    
                  </div>
                  
                  <div className="pure-u-1 u-align-center">
                    {best_fixed_link}<br/>
                    <a href="/awards/best-mobile">Browse Best Mobile Network Awards</a><br/>
                  </div>
                </div>
                <div className="pure-u-1 pure-u-md-1-6" />
              </div>
            </div>
          )}
          {/* Best Fixed End */}

          {/* Marketing and Brand Programs Start */}
          <div className="section section-lg section-grey">
            <div className="container">
              <div className="pure-g">
                <div className="pure-u-1 pure-u-md-1-6" />
                <div className="pure-u-1 pure-u-md-2-3 u-c">
                  <h1 className={`u-align-center ${styles.methodologyListHeader}`}>Marketing and brand programs</h1>
                  <p className={styles.methodologyParagraph}>
                    Ookla licenses data access to help companies both understand and demonstrate the benefits of their
                    networks. With claims backed by Ookla, you can differentiate yourself in the market with meaningful,
                    verifiable marketing and brand campaigns that potential and existing customers trust.
                  </p>
                  <p className={styles.methodologyParagraph}>
                    Licensees can make Noncompetitive Marketing Claims about their network alone or Competitive
                    Marketing Claims which can be made about a network in relation to others in the market; this could
                    be made by a provider or another company using the data to make a comparison.
                  </p>
                </div>
                <div className="pure-u-1 pure-u-md-1-6" />
                <div className="pure-u-1 u-align-center">
                  <br />
                  <br />
                  <Link to="/" className="btn">
                    Back to Speedtest Awards
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Marketing and Brand Programs End */}
        </div>
      </Layout>
    );
  }
}
